import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ApiClient from "../../../apis/Api-client";
import { END_POINT } from "../../../utils/End-points";
import { useSelector } from "react-redux";
import GooglePayButton from "../../paymenthistory/PaymentButton";
import {
  selectTriggered,
  setTriggered,
} from "../../../core/store/redux/slices/DashboardApi-slice";
import { useDispatch } from "react-redux";
import { errorToster, successToster } from "../../../shared/toster/Toster";
import ConfirmationDlgBox from "../confirmation-popup";
import moment from "moment/moment";
import RecordPaymentConfig from "../../../config/forms/RecordPayment-config";
import { useCallback, useEffect } from "react";
import { useState } from "react";
import { format } from "date-fns-tz";
import { Helper } from "../../../utils/Helpers";
import { useTranslation } from "react-i18next";
import { Can, FEATURES, ACTIONS } from "../../../core/permissions";
const { roundOff, debounce } = new Helper();

const RecordPayment = ({
  bookingData,
  handleCloseModal = () => { },
  handleClosePopover = () => { },
  resetData = () => { },
}) => {
  const { t } = useTranslation();
  const { api } = ApiClient();
  const isTriggered = useSelector(selectTriggered);
  const dispatch = useDispatch();
  const [paymentsTypes, setPaymentsTypes] = useState([]);
  const [paymentDetail, setPaymentDetail] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [overpayOpen, setOverpayOpen] = useState(false);
  const [pendingPayment, setPendingPayment] = useState(null);

  const totalPayment = roundOff(Number(paymentDetail?.total_booking_due || 0));
  // const totalPayment =
  //   roundOff(Number(paymentDetail?.due_amount || 0)) +
  //   roundOff(Number(paymentDetail?.reservation_amount || 0));
  // const totalPayment = roundOff(Number(paymentDetail?.due_amount || 0));

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    resolver: yupResolver(RecordPaymentConfig(totalPayment)),
  });

  const { paid_amount, payment_type_id, remarks } = watch();

  const themeStyles = useTheme();
  let primaryColor = themeStyles.palette.primary.main;
  let contrastText = themeStyles.palette.primary.contrastText;

  const debouncedcreatePaymentData = useCallback(
    debounce((data) => {
      createPaymentData(data);
    }, 1000),
    []
  );

  const onSubmit = (data) => {
    if (!!data.paid_amount && Number(data.paid_amount) > totalPayment) {
      setPendingPayment(data);
      setOverpayOpen(true);
      return;
    }
    debouncedcreatePaymentData(data);
  };

  const confirmOverpay = () => {
    setOverpayOpen(false);
    if (pendingPayment) debouncedcreatePaymentData(pendingPayment);
    setPendingPayment(null);
  };

  const cancelOverpay = () => {
    setPendingPayment(null);
  };

  useEffect(() => {
    if (!!bookingData?.booking_id) {
      setInitialData(bookingData?.booking_id);
    }
  }, [bookingData?.booking_id]);

  const setInitialData = async (booking_id) => {
    try {
      const [paymentTypes, paymentDetail] = await Promise.all([
        api
          .get(END_POINT.PAYMENT.GET_ALL_PAYMENT_TYPE)
          .then((res) => res.data.data || [])
          .catch(() => []),
        api
          .get(
            `${END_POINT.PAYMENT.GET_PAYMENT_DETAIL_BY_BOOKING}${booking_id}`
          )
          .then((res) => res.data.data || null)
          .catch(() => null),
      ]);

      setPaymentDetail(paymentDetail);
      setPaymentsTypes(paymentTypes);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const createPaymentData = async (data) => {
    try {
      setIsSubmitted(true);
      let paymentData = {
        booking_id: bookingData.booking_id,
        payment_date: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        paid_through: "Record Payment",
        paid_amount: data.paid_amount,
        payment_type_id: data.payment_type_id,
        remarks: data.remarks,
      };
      let paymentRes = await api.post(
        END_POINT.PAYMENT.CREATE_PAYMENT,
        paymentData
      );

      if (paymentRes?.status === 200) {
        handleClosePopover();
        resetData();
        reset();
        dispatch(setTriggered(!isTriggered));
        successToster(
          <span
            dangerouslySetInnerHTML={{
              __html: t(
                "pages.guest_history_page.alert.payment_by_successfully_saved",
                {
                  name: bookingData?.name,
                }
              ),
            }}
          />
        );
      }
    } catch (error) {
      errorToster(t("common_components.alert.something_went_wrong"));
    } finally {
      setTimeout(() => {
        setIsSubmitted(false);
      }, 2000);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid
        container
        columnGap={"2.8%"}
        rowGap={{ xs: "3vw", sm: 0 }}
        sx={{
          width: { xs: "91.795vw", sm: "69.23vw", md: "40vw" },
          padding: "3% 5%",
        }}
      >
        <Grid item xs={6.5} sm={5.83} sx={{ marginBottom: { sm: "5%" } }}>
          <Typography
            sx={{
              fontSize: { xs: "3.846vw", sm: "2.4vw", md: "1.389vw" },
              color: "#252525",
              fontWeight: 700,
              fontFamily: "Lato, sans-serif",
            }}
          >
            {t("common_components.record_payment.record_payment")}
          </Typography>
        </Grid>
        <Grid item xs={5} sm={5.83}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "right",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "3.121vw", sm: "1.916vw", md: "1.111vw" },
                color: primaryColor,
                fontWeight: 600,
              }}
            >
              {bookingData?.name}
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          xs={5.8}
          sm={5.83}
          sx={{ marginBottom: { xs: "1%", sm: "6%" } }}
        >
          <FormControl fullWidth>
            <TextField
              value={moment().format("MM/DD/YYYY")}
              size="small"
              disabled
              label={t("common_components.record_payment.date")}
              {...register("payment_date")}
              InputProps={{
                readOnly: true,
                sx: {
                  fontSize: { xs: "2.564vw", sm: "1.918vw", md: "1.111vw" },
                  color: "#727272",
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: { xs: "2.564vw", sm: "1.918vw", md: "1.111vw" },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  fontSize: { xs: "2.564vw", sm: "1.439vw", md: "0.833vw" },
                },
              }}
            />
          </FormControl>
        </Grid>

        <Grid
          item
          xs={5.8}
          sm={5.83}
          sx={{ marginBottom: { sm: "1%", md: 0 } }}
        >
          <TextField
            label={t("common_components.record_payment.amount")}
            defaultValue={paid_amount}
            variant="outlined"
            type="number"
            size="small"
            className="NoSpinnerTextField no-spinner"
            onInput={(e) => {
              let { value } = e.target;
              e.target.value =
                e.target.value == 0 ? null : value.replace(/[^0-9]/g, "");
            }}
            inputProps={{ min: 1 }}
            fullWidth
            error={!!errors["paid_amount"] && !!errors["paid_amount"]?.message}
            helperText={
              errors["paid_amount"]?.message
                ? t(
                  `common_components.record_payment.alert.${errors[
                    "paid_amount"
                  ]?.message
                    .toLowerCase()
                    .replace(/\s+/g, "_")}`
                )
                : ""
            }
            {...register("paid_amount", { required: true })}
            InputProps={{
              sx: {
                fontSize: { xs: "2.564vw", sm: "1.918vw", md: "1.111vw" },
                color: "#727272",
              },
            }}
            InputLabelProps={{
              sx: { fontSize: { xs: "2.564vw", sm: "1.918vw", md: "1.111vw" } },
            }}
            FormHelperTextProps={{
              sx: { fontSize: { xs: "2.564vw", sm: "1.439vw", md: "0.833vw" } },
            }}
          />
        </Grid>

        <Grid item xs={5.8} sm={5.83}>
          <FormControl fullWidth>
            <TextField
              select
              defaultValue={payment_type_id}
              size="small"
              label={t("common_components.record_payment.payment_mode")}
              {...register("payment_type_id", { required: true })}
              error={
                !!errors["payment_type_id"] &&
                !!errors["payment_type_id"]?.message
              }
              helperText={
                errors["payment_type_id"]?.message
                  ? t(
                    `common_components.record_payment.alert.${errors[
                      "payment_type_id"
                    ]?.message
                      .toLowerCase()
                      .replace(/\s+/g, "_")}`
                  )
                  : ""
              }
              InputProps={{
                sx: {
                  fontSize: { xs: "2.564vw", sm: "1.918vw", md: "1.111vw" },
                  color: "#727272",
                },
              }}
              InputLabelProps={{
                sx: {
                  fontSize: { xs: "2.564vw", sm: "1.918vw", md: "1.111vw" },
                },
              }}
              FormHelperTextProps={{
                sx: {
                  fontSize: { xs: "2.564vw", sm: "1.439vw", md: "0.833vw" },
                },
              }}
            >
              {paymentsTypes?.map((option) => (
                <MenuItem
                  key={option.payment_type_id}
                  value={option.payment_type_id}
                  sx={{
                    fontSize: { xs: "4.1vw", sm: "1.918vw", md: "1.111vw" },
                  }}
                >
                  {t(
                    `payment_mode_dropdown.${option.payment_type
                      .toLowerCase()
                      .replace(/\s+/g, "_")}`
                  )}
                </MenuItem>
              ))}
            </TextField>
          </FormControl>
        </Grid>

        <Grid item xs={5.8} sm={5.83}>
          <TextField
            label={t("common_components.record_payment.remarks")}
            defaultValue={remarks}
            variant="outlined"
            type="text"
            size="small"
            onInput={(e) => {
              let { value } = e.target;
              e.target.value = value.replace(/^\s+/, "");
            }}
            fullWidth
            {...register("remarks")}
            InputProps={{
              sx: {
                fontSize: { xs: "2.564vw", sm: "1.918vw", md: "1.111vw" },
                color: "#727272",
              },
            }}
            InputLabelProps={{
              sx: { fontSize: { xs: "2.564vw", sm: "1.918vw", md: "1.111vw" } },
            }}
            FormHelperTextProps={{
              sx: { fontSize: { xs: "2.564vw", sm: "1.439vw", md: "0.833vw" } },
            }}
          />
        </Grid>

        <Grid item xs={12} sx={{ margin: "1.5% 0 3.5% 0" }}>
          <Typography
            sx={{ fontSize: { xs: "2.821vw", sm: "1.918vw", md: "1.111vw" } }}
          >
            {t("common_components.record_payment.payment_due")} :{" "}
            <span
              style={{
                fontWeight: 700,
                fontSize: { xs: "3.077vw", sm: "1.918vw", md: "1.111vw" },
              }}
            >
              {totalPayment ? `₹${totalPayment}` : "₹0"}
            </span>
          </Typography>
          {/* <GooglePayButton></GooglePayButton> */}
        </Grid>


        <Grid item xs={5.83}>
          <Button
            fullWidth
            onClick={handleCloseModal}
            variant="outlined"
            sx={{
              fontWeight: 700,
              fontSize: { xs: "4.1vw", sm: "1.918vw", md: "1.111vw" },
            }}
          >
            {t("common_components.record_payment.cancel")}
          </Button>
        </Grid>

        <Grid xs={5.83}>
          <Can feature={FEATURES.PAYMENTS} action={ACTIONS.RECORD_PAYMENT}>
            <Button
              fullWidth
              disabled={!paid_amount || isSubmitted}
              variant="contained"
              type="submit"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "4.1vw", sm: "1.918vw", md: "1.111vw" },
              }}
            >
              {t("common_components.record_payment.save")}
            </Button>
          </Can>
        </Grid>
      </Grid>

      <ConfirmationDlgBox
        open={overpayOpen}
        setOpen={setOverpayOpen}
        label={
          <Box
            component="span"
            sx={{ color: "#DEA829", WebkitTextFillColor: "#DEA829" }}
          >
            {t("common_components.record_payment.alert.paying_more_than_due")}
          </Box>
        }
        confirmFunction={confirmOverpay}
        cancelFunction={cancelOverpay}
      />
    </form>
  );
};
export default RecordPayment;
